import React from "react";
import {
  Signup,
  Login,
  Auth,
  ForgotPassword,
} from "components/Auth/AuthModule";
import Assistants from "components/admin/assistants";
import NoMatch from "components/global/NoMatch";
import UpdateProfile from "components/global/UpdateProfile";
import { AuthProvider } from "contexts/AuthContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Admin from "components/admin/admin";
import "global.css";
import OnlyDesktop from "./global/OnlyDesktop";
import Assistant from "./admin/assistant";

var isMobile = navigator.userAgent.match(
  /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
);

const App = () => {
  return (
    <>
      {isMobile ? (
        <OnlyDesktop />
      ) : (
        <Router>
          <AuthProvider>
            <Routes>
              <Route path="admin" element={<Admin />}>
                <Route
                  path="update-profile"
                  element={<UpdateProfile />}
                ></Route>
                <Route path="assistants" element={<Assistants />}></Route>
                <Route path="assistant/:id" element={<Assistant />}></Route>
                <Route path="" element={<Navigate to="assistants" />} />
              </Route>
              <Route path="auth" element={<Auth />}>
                <Route path="signup" element={<Signup />} />
                <Route path="login" element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="*" element={<NoMatch />} />
              </Route>
              <Route path="" element={<Navigate to="admin/assistants" />} />
            </Routes>
          </AuthProvider>
        </Router>
      )}
    </>
  );
};

export default App;
